import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  helpCenterButton: {
    border: "1px solid ".concat(palette.shades[300])
  }
});
export default useStyles;